import { render, staticRenderFns } from "./warning.html?vue&type=template&id=3fe63226&scoped=true&"
import script from "./warning.vue?vue&type=script&lang=ts&"
export * from "./warning.vue?vue&type=script&lang=ts&"
import style0 from "./warning.scss?vue&type=style&index=0&id=3fe63226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe63226",
  null
  
)

export default component.exports